import React from 'react';
import { ServerCrash } from 'lucide-react';

export interface QueryErrorProps {
  message?: string;
  onRetry?: () => void;
}

/**
 * État d'erreur générique pour les requêtes API.
 * Affiche un message et un bouton « Réessayer ».
 */
export function QueryError({
  message = 'Impossible de charger les données',
  onRetry,
}: QueryErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <ServerCrash size={40} className="text-slate-300 dark:text-slate-600 mb-4" />
      <h3 className="text-base font-semibold text-slate-600 dark:text-slate-300 mb-1">
        {message}
      </h3>
      <p className="text-sm text-slate-400 dark:text-slate-500 mb-5">
        Vérifiez votre connexion ou réessayez plus tard.
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="px-4 py-2.5 bg-brand-500 hover:bg-brand-600 text-white text-sm font-medium rounded-lg transition-colors"
        >
          Réessayer
        </button>
      )}
    </div>
  );
}
